<template>
  <!-- start 弹窗外层 -->
  <div class="dialog-box" v-if="open">
    <!-- start 测试时间到期弹窗 -->
    <div class="time-expired-popup">
      <div class="time-expired-popup-header">
        <div class="time-expired-popup-header-info">
          <img
            class="time-expired-popup-header-info-icon"
            src="@/assets/images/xiao-header-icon.png"
          />
          <span class="time-expired-popup-header-info-title">打字通</span>
        </div>
        <div class="closed-container" @click="close">
          <img
            class="time-expired-popup-header-close"
            src="@/assets/images/white-close-icon.png"
          />
        </div>
      </div>
      <div class="time-expired-popup-content">
        <div class="time-expired-popup-content-title-info">
          <img
            class="time-expired-popup-content-title-info-icon"
            src="@/assets/images/xiao-icon.png"
          />
          <div class="time-expired-popup-content-title-info-content">
            <div class="time-expired-popup-content-title-info-content-grade">
              练习成绩：<span class="performance"
                >{{ typingSpeed }}字/分钟</span
              >
            </div>
            <div class="time-expired-popup-content-title-info-content-info">
              每天勤奋练习会有意外的收获哦~
            </div>
          </div>
        </div>
        <div class="time-expired-popup-content-data-info">
          <div class="time-expired-popup-content-data-info-lists">
            时间：<span
              class="time-expired-popup-content-data-info-list-data"
              >{{ formatSeconds(this.times) }}</span
            >
          </div>
          <div
            class="time-expired-popup-content-data-info-list time-expired-popup-content-data-info-list-left"
          >
            字数：<span class="time-expired-popup-content-data-info-list-data"
              >{{ totalNumbeWords }}字</span
            >
          </div>
          <div
            class="time-expired-popup-content-data-info-list time-expired-popup-content-data-info-list-left"
          >
            速度：<span class="time-expired-popup-content-data-info-list-data"
              >{{ typingSpeed }}字/分</span
            >
          </div>
          <div
            class="time-expired-popup-content-data-info-list time-expired-popup-content-data-info-list-left"
          >
            正确率：<span class="time-expired-popup-content-data-info-list-data"
              >{{ accuracy }}%</span
            >
          </div>
        </div>
        <div class="practice-again" @click="playAgain">
          再练一次
          <img
            class="practice-again-img"
            src="@/assets/images/test-again-icon.png"
          />
        </div>
      </div>
    </div>
    <!-- end 测试时间到期弹窗 -->
  </div>
  <!-- end 弹窗外层 -->
</template>

<script>
export default {
  name: "TimeExpiredPopup",
  data() {
    return {};
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    totalNumbeWords: {
      type: Number,
      default: 0,
    },
    typingSpeed: {
      type: Number,
      default: 0,
    },
    accuracy: {
      type: String,
      default: "0",
    },
    times: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    // 关闭弹窗
    close() {
      this.$emit("close");
    },
    // 再玩一次
    playAgain() {
      this.$emit("playAgain");
    },
    // 转换时间单位
    formatSeconds(value) {
      let result = parseInt(value);

      /*let h =
        Math.floor((result / 3600) % 24) < 10
          ? "0" + Math.floor((result / 3600) % 24)
          : Math.floor((result / 3600) % 24);
          */

      let m =
        Math.floor((result / 60) % 60) < 10
          ? "0" + Math.floor((result / 60) % 60)
          : Math.floor((result / 60) % 60);

      let s =
        Math.floor(result % 60) < 10
          ? "0" + Math.floor(result % 60)
          : Math.floor(result % 60);

      return m + "分" + s + "秒";
    },
  },
};
</script>

<style scoped lang="scss">
.dialog-box {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  .time-expired-popup {
    width: 670px;
    height: 370px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    outline: none;
    background: #edf5fd;
    border: 1px solid #6090c0;
    border-radius: 2px 2px 2px 2px;
    box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.1607843137254902);
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    flex-flow: column;
    .time-expired-popup-header {
      width: 100%;
      height: 38px;
      background-image: url("../assets/images/time-expired-popup-header.png");
      background-size: 100% 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 12px;
      box-sizing: border-box;
      .time-expired-popup-header-info {
        display: flex;
        align-items: center;
        .time-expired-popup-header-info-icon {
          width: 20px;
          height: 20px;
        }
        .time-expired-popup-header-info-title {
          margin-left: 4px;
          color: #ffffff;
          font-weight: 400;
          font-size: 14px;
        }
      }
      .closed-container {
        width: 40px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .time-expired-popup-header-close {
          width: 14px;
          height: 14px;
          cursor: pointer;
        }
      }
      .closed-container:hover {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }
    .time-expired-popup-content {
      width: 100%;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      align-items: center;
      flex-flow: column;

      .time-expired-popup-content-title-info {
        margin-top: 52px;
        display: flex;
        .time-expired-popup-content-title-info-icon {
          width: 90px;
          height: 90px;
        }
        .time-expired-popup-content-title-info-content {
          margin-left: 20px;
          .time-expired-popup-content-title-info-content-grade {
            margin-top: 8px;
            color: #000000;
            font-weight: 400;
            font-size: 16px;
            .performance {
              color: #fc7a07;
              font-weight: 400;
              font-size: 26px;
            }
          }
          .time-expired-popup-content-title-info-content-info {
            margin-top: 10px;
            color: #d18225;
            font-size: 22px;
            font-weight: 400;
          }
        }
      }
    }
    .time-expired-popup-content-data-info {
      margin-top: 27px;
      width: 590px;
      height: 44px;
      background: #fdf1b7;
      box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.1607843137254902);
      border: 1px solid #ffab72;
      display: flex;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
      .time-expired-popup-content-data-info-list {
        flex: 1;
        color: #000000;
        font-weight: 400;
        font-size: 16px;
      }
      .time-expired-popup-content-data-info-lists {
        width: 120px;
        color: #000000;
        font-weight: 400;
        font-size: 16px;
      }
      .time-expired-popup-content-data-info-list-data {
        color: #fc7a07;
      }
      .time-expired-popup-content-data-info-list-left {
        margin-left: 12px;
      }
    }
    .practice-again {
      margin-top: 38px;
      width: 122px;
      height: 34px;
      background: linear-gradient(180deg, #80c3fd 0%, #4aa3fc 100%);
      border-radius: 2px 2px 2px 2px;
      border: 1px solid #96cefd;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-weight: 400;
      font-size: 16px;
      cursor: pointer;
      .practice-again-img {
        margin-top: 4px;
        width: 24px;
        height: 24px;
      }
    }
  }
}
</style>
